import React from "react";
import { Typography, Box, Grid, Paper, Chip } from "@mui/material";

const fontSxTitle = {
  fontSize: ["1rem", "1rem", "1rem", "1rem", "1.25rem", "1.25rem"],
};

const fontSx = {
  fontSize: ["0.75rem", "0.75rem", "0.75rem", "0.75rem", "1rem", "1rem"],
};

const UnreadBadge = ({ count }) =>
  count > 0 ? (
    <Chip size="small" color="error" label={count} sx={{ ml: "0.5rem" }} />
  ) : null;

const OrgList = ({ orgs = [], selectedOrg = null, onSelectOrg }) => {
  const getSelectedStyle = (org) =>
    org === selectedOrg ? { fontWeight: "bold", color: "status.info" } : {};

  const totalDevices = orgs.reduce((sum, orgInfo) => sum + orgInfo.devices, 0);
  const totalUnreadMaintenance = orgs.reduce(
    (sum, orgInfo) => sum + (orgInfo.unreadMaintenanceCount || 0),
    0
  );

  return (
    <Paper
      className={
        "flex bg-white rounded-xl border-4 border-transparent transition-opacity duration-1000"
      }
    >
      <Box
        sx={{
          width: "100%",
          px: "1rem",
          py: "1rem",
        }}
      >
        <Grid container spacing={1}>
          <Grid
            size={12}
            container
            sx={{ py: "1rem", cursor: "pointer" }}
            spacing={0}
            key={"org-all"}
            onClick={() => onSelectOrg(null)}
          >
            <Grid size={9}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  sx={{ ...fontSxTitle, ...getSelectedStyle(null) }}
                  className={"text-gray-600"}
                >
                  All
                </Typography>
                <UnreadBadge count={totalUnreadMaintenance} />
              </Box>
            </Grid>
            <Grid size={3}>
              <Typography sx={fontSx} className={"text-gray-600"}>
                Devices ({totalDevices})
              </Typography>
            </Grid>
          </Grid>

          {orgs.map((orgInfo) => (
            <Grid
              container
              size={12}
              sx={{ py: "1rem", cursor: "pointer" }}
              spacing={0}
              key={`org-${orgInfo.org}`}
              onClick={() => onSelectOrg(orgInfo.org)}
            >
              <Grid size={9}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography
                    sx={{ ...fontSxTitle, ...getSelectedStyle(orgInfo.org) }}
                    className={"text-gray-600"}
                  >
                    {orgInfo.org}
                  </Typography>
                  <UnreadBadge count={orgInfo.unreadMaintenanceCount} />
                </Box>
              </Grid>
              <Grid size={3}>
                <Typography sx={fontSx} className={"text-gray-600"}>
                  Devices ({orgInfo.devices})
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Paper>
  );
};

export default OrgList;
